import React, { useState } from "react";
import PulldownMenu from "components/Common/PulldownMenu";
import EditModal from "./EditModal";
import DeleteModal from "./DeleteModal";
import EditIcon from "images/icon/edit_16_on.svg";
import DeleteIcon from "images/icon/delete_16_on.svg";

interface Props {
  isShowMenu: boolean;
  chatTitle: string;
  onCloseMenu: () => void;
  onChatTitleEdit: (newTitle: string) => void;
  onChatDelete: () => void;
}

const HistoryActions: React.FC<Props> = ({
  isShowMenu,
  chatTitle,
  onCloseMenu,
  onChatTitleEdit,
  onChatDelete
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  return (
    <div>
      {isShowMenu && (
        <PulldownMenu
          list={[
            {
              label: "名前を変更",
              icon: <img src={EditIcon} alt="編集" />,
              key: "edit"
            },
            {
              label: "削除",
              icon: <img src={DeleteIcon} alt="削除" />,
              key: "delete"
            }
          ]}
          onClick={(key: string) => {
            if (key === "edit") {
              setEditModalOpen(true);
            } else if (key === "delete") {
              setDeleteModalOpen(true);
            }
            onCloseMenu();
          }}
          onOutsideClick={onCloseMenu}
        />
      )}
      <EditModal
        isOpen={editModalOpen}
        defaultTitle={chatTitle}
        onClose={() => setEditModalOpen(false)}
        onChatTitleEdit={onChatTitleEdit}
      />
      <DeleteModal
        isOpen={deleteModalOpen}
        chatTitle={chatTitle}
        onClose={() => setDeleteModalOpen(false)}
        onChatDelete={onChatDelete}
      />
    </div>
  );
};

export default HistoryActions;
